import React from "react";
import { detectLinks } from "hhn-commons";
import { IMessageContentTypeBubble } from "../../MessagePanel";
import TextContentWrapper from "../../../common/TextContentWrapper";
import { Link } from "@mui/material";
import ExpandableText from "../../../common/ExpandableText";

export const createWebLinkElement = (
  key: string,
  raw: string,
  href: string,
  isEmail: boolean,
) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {};

  return (
    <Link
      key={key}
      href={href}
      underline="none"
      title={isEmail ? `Email ${raw}` : `Open ${raw}`}
      sx={{ color: "primary.main", cursor: "pointer" }}
      target={isEmail ? "_self" : "_blank"}
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {raw}
    </Link>
  );
};

const LinkContent = ({ message }: IMessageContentTypeBubble) => {
  const messageData = message.getMessage();
  const isMessageTypeInfo = message.isInfoMessage();
  const text = messageData.body ?? messageData.fallbackMessage ?? "";

  if (isMessageTypeInfo) {
    return (
      <TextContentWrapper>
        <ExpandableText>{text} </ExpandableText>
      </TextContentWrapper>
    );
  }

  const elements = detectLinks(text, createWebLinkElement);

  return (
    <TextContentWrapper>
      <ExpandableText>{elements}</ExpandableText>
    </TextContentWrapper>
  );
};

export default LinkContent;
